import React, { Component, createRef } from 'react';
import cx from 'classnames';
import moment from 'moment';
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';

import { Overlay } from './../../UIComponents';

import Tags from '../Tags';
import Transcript from '../Transcript';
import StatusSelectDropdown from '../../DropdownMenu/ReportSelection';
import MarkAsResolved from '../../DropdownMenu/MarkAsResolved';
import Layover from './ReportOveralay';
import BlockOverlay from './BlockOverlay';
import OptoutOverlay from './OptoutOverlay';
import CreateContact from './CreateContact';
import SelectContact from './SelectContact';
import StaffAssignList from '../../DropdownMenu/StaffAssignList';
import ConversationFilter from '../../DropdownMenu/ConversationFilter';
import Loading from '../../common/Loading';

import helpers from '../helpers';

import Logo from '../../../assets/images/truelark_icon.svg';
import only_notes from '../../../assets/images/only_notes.svg';
import full_conversation from '../../../assets/images/full_conversation.svg';
import full_conversation_bottom from '../../../assets/images/full_conversation_bottom.svg';
import conversation_user from '../../../assets/images/conversation_user.png';
import Ellipse from '../../../assets/images/Ellipse.svg';
import Line from '../../../assets/images/Line.svg';
import optout_1 from '../../../assets/images/optout_1.svg';
import optout_2 from '../../../assets/images/optout_2.svg';
import closeIcon from '../../../assets/images/x_icon_gray.png';
import Voicecall from '../../../assets/images/lucide_audio-lines.svg';

import Profile from '../../Header/img/profile.png'
import './index.scss';
import contactsList from '../usersearch.json';
import utils from '../../../lib/utils';
import classNames from 'classnames';
import CustomTags from './CustomTag';


const conversationfilter = [
  { 'value': 'FULL', 'label': 'Full conversation' },
  { 'value': 'NOTES_UPDATES', 'label': 'Only notes and updates' }
]
const generateTemplate = (text, highlight) => {
  const sanitizedHighlight = highlight.replace(/[^\w\s]/gi, '');
  if (sanitizedHighlight) {
    const parts = text.split(new RegExp(`(${sanitizedHighlight})`, 'gi'));
    const parsedString = <span>{parts.map(part => part.toLowerCase() === sanitizedHighlight.toLowerCase() ? <span className="contact-search-result_container_contact_heighlight">{part}</span> : part)}</span>;
    return parsedString;
  } else {
    return <span>{text}</span>
  }
}

const getPhoneNumber = (contact) => {
  if (contact.phone) {
    return utils.formatPhoneNumber(contact.phone);
  } else {
    const phone_number = contact.contacts.filter(phone => phone.type === 'PHONE');
    return phone_number.length > 0 ? utils.formatPhoneNumber(phone_number[0].value) : '';
  }
}
const getEmail = (contact) => {
  if (contact.email) {
    return contact.email;
  } else {
    const email = contact.contacts.filter(phone => phone.type === 'EMAIL');
    return email.length > 0 ? utils.formatPhoneNumber(email[0].value) : '';
  }
}

const getFullName = (selected, list, allAssignmentMap, userid) => {
  const assigned_staff = list.filter(staff => staff.id === selected);
  const staff = assigned_staff.length > 0 ? assigned_staff[0] : (selected ? helpers.getOtherStaff(selected, allAssignmentMap) : { firstName: 'NA', lastName: 'NA' });

  if (!selected) {
    return 'TrueLark'
  } else if (userid === staff.id) {
    return staff.firstName + ' ' + staff.lastName + ' (Me)';
  } else if (staff.lastName) {
    return staff.firstName + ' ' + staff.lastName;
  } else {
    return staff.firstName;
  }
}
const isOtherStaff = (selected, list) => {
  const assigned_staff = list.filter(staff => staff.id === selected);
  return (assigned_staff.length === 0 && selected)
}

const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const ltrim = (str) => {
  if (!str) return str;
  return str.replace(/^\s+/g, '');
};

Modal.setAppElement('#root');

class ConversationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusDropdownVisibility: false,
      reportOverlay: false,
      blockOverlay: false,
      optoutOverlay: false,
      assignedUser: null,
      userdropdownVisibility: false,
      conversationFilterSelect: 'FULL',
      filterdropdownVisibility: false,
      needsattentionVisibility: false,
      filteredContacts: [],
      searchText: null,
      selectedContact: null,
      createNewContact: false,
      selectContactpage: false,
      calledDetailsAPI: false,
      showErrorMessage: false,
      showUndoNeedsAttention: false,
      undo: false,
      createdContact: {},
      searchLoading: false,
      isCreatingNewConversation: false,
      showCreateContactPopup: false,
      showRedirectContactPopup: false,
      showCallerNameSucess: false,
      showCallerNameFailure: false,
      customTagDropdownVisibility: false,
      removingTag:{},
    };
    this.wrapperRef = createRef();
    this.dropdownRef = createRef();
    this.userwrapperRef = createRef();
    this.userdropdownRef = createRef();
  }
  componentDidMount() {
    const { conversation, getConversationDetailsbyUser, searchConversationText } = this.props;
    if (
      (conversation &&
        !utils.isEmptyObject(conversation) &&
        !conversation.details) ||
      (conversation && conversation.details && conversation.details.doApicall)
    ) {
      let sessionIdArray = [];
      sessionIdArray = conversation.otherconversation.map((conversation) => {
        return conversation.id;
      });
      sessionIdArray.push(conversation.id);
      getConversationDetailsbyUser({
        businessId: conversation.bzId,
        sessionId: sessionIdArray,
        rootid: conversation.id,
        convuserId: conversation.userId,
        search: searchConversationText?.length > 0,
      });
    }
  }
  componentDidUpdate(prevProps) {
    const { conversation } = this.props;

    // Check if conversation.id has changed
    if (prevProps.conversation.id !== conversation.id) {
      this.callDetailsAPI(conversation);
    }
  }
  callDetailsAPI = (conversation) => {
    if (!conversation || utils.isEmptyObject(conversation)) return;
    const { searchConversationText } = this.props;
    let sessionIdArray = [];
    if (conversation.otherconversation) {
      sessionIdArray = conversation.otherconversation.map(c => c.id);
    }
    sessionIdArray.push(conversation.id);

    this.props.getConversationDetailsbyUser({
      businessId: conversation.bzId,
      sessionId: sessionIdArray,
      rootid: conversation.id,
      convuserId: conversation.userId,
      search: searchConversationText?.length > 0,
      selectedConversation: conversation,
    });

    console.log("API Call triggered for conversation:", conversation.id);
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.conversation &&
      this.props.conversation != nextProps.conversation
    ) {
      const { conversation } = nextProps;
      if (
        conversation &&
        conversation.notification_read_status === 'UNREAD' &&
        conversation.unread_count > 0 &&
        this.props.conversation.unread_count !== conversation.unread_count
      ) {
        this.props.readNotification(conversation.bzId, conversation.id);
      }
    }
    if (
      nextProps.conversations.ongoingSearch === false &&
      nextProps.conversations.ongoingSearch !=
      this.props.conversations.ongoingSearch
    ) {
      this.setState({
        filteredContacts: nextProps.conversations.contactSearch,
        searchLoading: false,
      });
    } else if (nextProps.conversations.ongoingSearch === true) {
      this.setState({
        filteredContacts: nextProps.conversations.contactSearch,
        searchLoading: true,
      });
    }
    if (
      nextProps.conversations.isAdvancedSearch === false &&
      nextProps.conversations.isAdvancedSearch !==
      this.props.conversations.isAdvancedSearch
    ) {
      this.setState({
        createNewContact: false,
        searchText: null,
        selectedContact: null,
        filteredContacts: [],
        selectContactpage: true,
      });
    }
    const currentnewConversation = this.props.conversations.conversations.filter(
      (conversation) => conversation.staffCreated,
    );
    const nextnewConversation = nextProps.conversations.conversations.filter(
      (conversation) => conversation.staffCreated,
    );
    if (nextnewConversation?.length < currentnewConversation?.length) {
      this.setState({
        createNewContact: false,
        searchText: null,
        selectedContact: null,
        filteredContacts: [],
      });
    }
    if (
      nextProps.conversations.postClinetNotes !==
      this.props.conversations.postClinetNotes
    ) {
      this.setState(
        {
          showErrorMessage: true,
        },
        () => this.clearErrorMessage(),
      );
    }
    if (
      nextProps.conversations.creatingNewConversation !==
      this.props.conversations.creatingNewConversation
    ) {
      if (nextProps.conversations.creatingNewConversation === false) {
        this.setState({
          selectedContact: null,
          createNewContact: false,
          searchText: null,
          filteredContacts: [],
          selectContactpage: false,
          isCreatingNewConversation: false,
          createdContact: {},
        });
      } else {
        this.setState({
          isCreatingNewConversation: true,
        });
      }
    }
    if (nextProps.createNewConversation !== this.props.createNewConversation) {
      if (nextProps.createNewConversation === false) {
        this.setState({
          createNewContact: false,
          searchText: null,
          filteredContacts: [],
          selectContactpage: false,
          isCreatingNewConversation: false,
          createdContact: {},
        });
      }
    }
    if (nextProps.conversation && utils.isEmptyObject(nextProps.conversation)) {
      this.props.hideDetailsViewForMobile();
    }
    if (nextProps.conversation?.newContactAdded && this.state.selectedContact) {
      this.setState({
        showCreateContactPopup: true,
      });
      setTimeout(() => {
        this.props.clearContactFlag(nextProps.conversation.id);
        this.setState({
          showCreateContactPopup: false,
        });
      }, 6000);
    }
    if (
      nextProps.conversation?.jumptoThis !==
      this.props.conversation?.jumptoThis &&
      nextProps.conversation?.jumptoThis === true
    ) {
      this.setState({
        showRedirectContactPopup: true,
      });
      setTimeout(() => {
        this.props.clearContactFlag(nextProps.conversation.id);
        this.setState({
          showRedirectContactPopup: false,
        });
      }, 6000);
    }
    if (
      nextProps.conversations.callerNameChangeSuccess === true &&
      nextProps.conversations.callerNameChangeSuccess !==
      this.props.conversations.callerNameChangeSuccess
    ) {
      this.setState({
        showCallerNameSucess: true,
      },
        () => this.clearErrorMessage(),
      );
    }
    if (
      nextProps.conversations.callerNameChangeFailure === true &&
      nextProps.conversations.callerNameChangeFailure !==
      this.props.conversations.callerNameChangeFailure
    ) {
      this.setState(
        {
          showCallerNameFailure: true,
        },
        () => this.clearErrorMessage(),
      );
    }
    if (
      nextProps.conversations.addingTagToUser === false &&
      nextProps.conversations.addingTagToUser !=
      this.props.conversations.addingTagToUser
    ) {
      this.setState({
        customTagDropdownVisibility: false,
      });
    }
    if (
      nextProps.conversations.removingTagToUser === false &&
      nextProps.conversations.removingTagToUser !=
      this.props.conversations.removingTagToUser
    ) {
      this.setState({
        customTagDropdownVisibility: false,
      });
    }
  }

  clearErrorMessage = () => {
    setTimeout(() => {
      this.setState({
        showErrorMessage: false,
        showCallerNameFailure: false,
        showCallerNameSucess: false
      });
    }, 3000);
  };
  setneedsattentionVisibility = (visibility) => {
    this.setState({
      needsattentionVisibility: visibility,
      ...(visibility && {
        userdropdownVisibility: !visibility,
        statusDropdownVisibility: !visibility,
        filterdropdownVisibility: !visibility,
      }),
    });
  };
  setStatusDropdownVisibility = (visibility) => {
    this.setState({
      statusDropdownVisibility: visibility,
      ...(visibility && {
        userdropdownVisibility: !visibility,
        needsattentionVisibility: !visibility,
        filterdropdownVisibility: !visibility,
      }),
    });
  };
  setuserdropdownVisibility = (visibility) => {
    this.setState({
      userdropdownVisibility: visibility,
      ...(visibility && {
        statusDropdownVisibility: !visibility,
        needsattentionVisibility: !visibility,
        filterdropdownVisibility: !visibility,
      }),
    });
  };
  setfilterdropdownVisibility = (visibility) => {
    this.setState({
      filterdropdownVisibility: visibility,
      ...(visibility && {
        userdropdownVisibility: !visibility,
        needsattentionVisibility: !visibility,
        statusDropdownVisibility: !visibility,
      }),
    });
  };
  assignUser = (user) => {
    const { conversation } = this.props;
    const assigned_to = user ? user.id : null;
    this.props.assignConversation(
      conversation.id,
      assigned_to,
      conversation.userId,
    );
    this.setState(
      {
        assignedUser: user,
      },
      () => {
        this.props.clearJumpSelectionFlags();
      },
    );
  };
  filterMessageType = (event) => {
    this.setState({
      conversationFilterSelect: event,
    });
  };
  handleStatusChange = (event) => {
    if (event === 'Report') {
      this.setreportOverlayVisibility(true);
    } else if (event === 'Block') {
      this.setblockOverlayVisibility(true);
    } else {
      this.setoptoutOverlayVisibility(true);
    }
  };
  handleConvStatusChange = (status) => {
    const {
      auth,
      business,
      selectedLocation,
      onStatusChange,
      conversation,
    } = this.props;
    const businessId =
      selectedLocation && !utils.isEmptyObject(selectedLocation)
        ? selectedLocation.studioId
        : auth.studio_id;
    onStatusChange({
      businessId: businessId,
      sessionId: conversation.id,
      data: {
        status: status,
        updated_by: auth.userid,
        updated_time: moment().toISOString(),
      },
    });
  };
  setblockOverlayVisibility = (visibility) => {
    this.setState({
      blockOverlay: visibility,
    });
  };
  setoptoutOverlayVisibility = (visibility) => {
    this.setState({
      optoutOverlay: visibility,
    });
  };
  setreportOverlayVisibility = (visibility) => {
    this.setState({
      reportOverlay: visibility,
    });
  };

  setCustomTagOverlayVisibility = (visibility) => {
    this.setState({
      customTagDropdownVisibility: visibility,
    });
  };

  debounceSearch = debounce(
    (req) => this.props.searchContact(req.bzid, req.searchText),
    500,
  );
  searchConversationFunc = (searchText) => {
    let filteredContacts = [];
    if (searchText.target.value.length > 0) {
      const { auth, selectedLocation } = this.props;
      const bzid =
        selectedLocation && !utils.isEmptyObject(selectedLocation)
          ? selectedLocation.studioId
          : auth.studio_id;
      this.debounceSearch({
        bzid,
        searchText: encodeURIComponent(searchText.target.value),
      });
    }
    this.setState({
      searchText: ltrim(searchText.target.value),
      filteredContacts,
      dontShowTransition: true,
    });
  };
  selectContact = (contact) => {
    this.setState({
      selectedContact: contact,
      createdContact: {},
      selectContactpage: false,
    });
    const { conversations } = this.props.conversations;
    const newlyCreated = conversations.filter(
      (conversation) => conversation.staffCreated,
    );
    const id = newlyCreated[0].id;
    const { auth, selectedLocation } = this.props;
    const bzid =
      selectedLocation && !utils.isEmptyObject(selectedLocation)
        ? selectedLocation.studioId
        : auth.studio_id;
    const email = contact.email
      ? contact.email
      : contact.contacts &&
        contact.contacts.filter((contact) => contact.type === 'EMAIL').length >
        0
        ? contact.contacts.filter((contact) => contact.type === 'EMAIL')[0].value
        : '';
    const phone = contact.phone
      ? contact.phone
      : contact.contacts &&
        contact.contacts.filter((contact) => contact.type === 'PHONE').length >
        0
        ? contact.contacts.filter((contact) => contact.type === 'PHONE')[0].value
        : '';
    const conversation_object = {
      business_id: bzid,
      user: {
        first_name: contact.first_name || contact.firstName || null,
        last_name: contact.last_name || contact.lastName || null,
        phone: phone,
        email: email,
      },
    };
    const isNewlyCreated = contact.hasOwnProperty('firstName');
    this.props.createContactInBackend(
      bzid,
      id,
      conversation_object,
      isNewlyCreated,
    );
  };
  clearContactSelection = () => {
    this.setState({
      selectedContact: null,
      searchText: null,
      filteredContacts: [],
      createdContact: {},
    });
  };
  saveContact = (data) => {
    this.setState({
      createdContact: data,
      selectedContact: null,
    });
    const { auth, selectedLocation } = this.props;
    const bzid =
      selectedLocation && !utils.isEmptyObject(selectedLocation)
        ? selectedLocation.studioId
        : auth.studio_id;
    this.props.searchContact(bzid, data, true);
  };
  createContact = (flag) => {
    this.setState({
      createNewContact: flag,
      selectedContact: null,
      filteredContacts: [],
    });
  };
  selectedContactToggle = (flag) => {
    this.setState({
      createNewContact: false,
      createdContact: {},
      searchText: null,
      selectedContact: null,
      filteredContacts: [],
      selectContactpage: flag,
    });
    // ,()=>{if(flag===false)
    //     {
    //         const { conversations } = this.props.conversations;
    //         const newlyCreated = conversations.filter(conversation=>conversation.staffCreated);
    //         const id = newlyCreated[0].id;
    //         this.props.removeNewConversation(id)
    //     }}
  };
  editContact = () => {
    this.setState({
      createNewContact: true,
      searchText: null,
      selectedContact: null,
      filteredContacts: [],
      selectContactpage: false,
    });
  };
  addNotes = (text, textType) => {
    const {
      auth,
      business,
      selectedLocation,
      onStatusChange,
      conversation,
      postClientNotes,
      conversations,
      sendMessage,
    } = this.props;
    const businessId =
      selectedLocation && !utils.isEmptyObject(selectedLocation)
        ? selectedLocation.studioId
        : auth.studio_id;
    const { notes } = conversation;
    if (text && text.trim().length > 0) {
      if (textType === 'NOTE') {
        const notestosave = {
          text: text,
          added_by: auth.userid,
          updated_time: moment()
            .utc()
            .toISOString(true)
            .split('.')[0],
        };
        let tempNote = { ...notes };
        tempNote.conversation_notes.push(notestosave);
        postClientNotes({
          businessId: businessId,
          sessionId: conversation.id,
          added_by: auth.userid,
          notes: tempNote,
        });
        tempNote.conversation_notes.pop();
        this.props.clearJumpSelectionFlags();
      } else {
        sendMessage({
          user_id: conversation.userId,
          session_id: conversation.id,
          message: text,
          business_id: businessId,
        });
        this.props.clearJumpSelectionFlags();
      }
    }
  };
  changeAutoResponseStatus = () => {
    const { conversation } = this.props;
    const status =
      conversation.auto_chat_status === 'ACTIVE' ? 'PAUSED' : 'ACTIVE';
    this.props.changeAutoResponse(conversation.id, status);
  };
  handleSearchResultCount = (displayData) => {
    const { brand_ids, businessName, studioId } = this.props.selectedLocation;
    let resultstring = 'No results found for the last 30 days';
    // if(brand_ids && !brand_ids.includes(studioId) && displayData.length === 0){
    //   resultstring = `No conversations found for ${businessName} location. Search all locations instead?`
    // }
    return resultstring;
  };
  onUndoClick = () => {
    clearTimeout(this.timeout);
    this.setState({
      showUndoNeedsAttention: false,
      needsattentionVisibility: false,
      undo: false,
    });
  };
  sortAndremoveDuplicate = (messages) => {
    const unique = [];
    messages.map((x) =>
      unique.filter((a) => a.id == x.id).length > 0 ? null : unique.push(x),
    );
    unique.sort((a, b) => a.timestamp - b.timestamp);
    return unique;
  };
  playVoiceMail = (conversation) => {
    const twilioRegex = /(https?:\/\/.*?\.mp3)/g;
    let voiceMails = [];
    const { details } = conversation;
    if (details && details.messages && details.messages.length > 0) {
      voiceMails = details.messages.filter((mail) =>
        mail.message.match(twilioRegex),
      );
    }
    const sortedvoicemail = this.sortAndremoveDuplicate(voiceMails);
    if (sortedvoicemail && sortedvoicemail.length > 0) {
      const URL = sortedvoicemail[0].message.match(twilioRegex)[0];
      window.open(URL, '_blank');
    }
  };
  isBlockedOrOptOut = (conversation, blockedNumbers, optoutnumbers) => {
    let status = {
      blocked: false,
      optout: false,
    };
    const isBlocked = blockedNumbers
      ? blockedNumbers.filter(
        (number) => number.user_phone === conversation.userPhone,
      )
      : [];
    const isOptout =
      optoutnumbers && optoutnumbers.recent_n_details
        ? optoutnumbers.recent_n_details.filter(
          (number) => number.phone_number === conversation.userPhone,
        )
        : [];
    if (isBlocked && isBlocked.length > 0) {
      status.blocked = true;
    }
    if (isOptout && isOptout.length > 0) {
      status.optout = true;
    }
    return status;
  };
  
  addCustomTags = (tags) => {
  
    const params = {
      tag_ids: tags.map(item => item.id)
    };
    
    this.props.addTagToUser(params, this.props?.conversation);
  }
  
  removeCustomTags = (tags) => {

    const params = {
      tag_ids: [tags.id]
    };
    console.log('params',params, this.props?.conversation);
    this.props.removeTagofUser(params, this.props?.conversation);
    this.setState({ removingTag: tags });
  }
  // erorReport,errorData,clearReportFlags,globalReport,typeofUser
  render() {
    const {
      conversation,
      conversations,
      auth,
      typeofUser,
      getConversationTranscripts,
      isLoadingTypescript,
      business,
      erorReport,
      errorData,
      clearReportFlags,
      getBlockUser,
      blockUser,
      clearBlockData,
      handleConversationClick,
      conversation_locations,
      StaffManagement,
      searchConversationText,
      sorted_list,
      addOnNotEnabled,
      autoResponseChange,
      allAssignmentMap,
      blockedNumbers,
      optoutnumbers,
      selectedLocation,
      showMobileDetailsView,
      hideDetailsViewForMobile,
      unblockPhone,
      softwares,
    } = this.props;
    const {
      statusDropdownVisibility,
      reportOverlay,
      blockOverlay,
      optoutOverlay,
      assignedUser,
      needsattentionVisibility,
      userdropdownVisibility,
      filterdropdownVisibility,
      conversationFilterSelect,
      filteredContacts,
      searchText,
      selectedContact,
      createNewContact,
      selectContactpage,
      showErrorMessage,
      showUndoNeedsAttention,
      createdContact,
      isCreatingNewConversation,
      showCreateContactPopup,
      showRedirectContactPopup,
      showCallerNameSucess,
      showCallerNameFailure,
      customTagDropdownVisibility,
      removingTag,
    } = this.state;
    const { details, auto_chat_status, notes, tags } = conversation;
    const { list } = StaffManagement;
    const {
      assignedConversation,
      postClinetNotes,
      errorMessage,
      isAdvancedSearch,
      advancedSearch,
      getconversationDetailsFail,
      custom_tags,
      addingTagToUser,
      removingTagToUser,
    } = conversations;
    const assignedList = allAssignmentMap.filter(
      (assignment) => assignment.assigned_user === conversation.userId,
    );
    const assignedTo =
      assignedList.length > 0 ? assignedList[0].assigned_to : null;
    const dropdownType =
      assignedList.length > 0
        ? assignedList[0].assigned_to == auth.userid
          ? 1
          : 2
        : 0;
    const createNewConversation =
      conversation && conversation.staffCreated ? true : false;
    const conversationStatus = helpers.getConversationStatus(conversation);
    const containing_locations = conversation_locations.filter((location) =>
      conversation.accounts.includes(location.studioId),
    );
    const annotations = helpers.getAnnotations(conversation);
    const logoName = helpers.getLogoName(assignedTo, list, allAssignmentMap);
    const blockStatus = this.isBlockedOrOptOut(
      conversation,
      blockedNumbers,
      optoutnumbers,
    );
    const assignment_disabled = conversation.status !== 'FINISHED' && conversation.textType === 'VOICE_CALL';
    console.log('conversations 123--->', custom_tags, conversation);
    return (
      <div
        className={cx('conversation-details', {
          'visible-conversation-details': showMobileDetailsView,
        })}
      >
        <div className="mobile-close-button" onClick={hideDetailsViewForMobile}>
          X
        </div>
        {searchConversationText &&
          searchConversationText.length &&
          !sorted_list.length ? (
          <div className="no-conversations">
            {this.handleSearchResultCount(sorted_list)}
          </div>
        ) : (
          <>
            {isLoadingTypescript || isCreatingNewConversation ? (
              <div className="loading-indicator">
                <Loading />
              </div>
            ) : (
              <>
                <div className="conversation-details_header">
                  <div className="conversation-details_header_basicinfo">
                    <div className="name-and-phone">
                      {!createNewConversation ? (
                        <>
                          <div
                            className={cx('name-and-phone_name', {
                              'has-associated-client':
                                conversation,
                            })}
                            onClick={() =>
                              handleConversationClick(conversation)
                            }
                          >
                            {helpers.getclientNameListMeta(
                              conversation,
                              typeofUser,
                            )}
                          </div>
                          <div className="name-and-phone_phone">
                            {helpers.getClientPhone(conversation)}
                          </div>
                          {blockStatus.blocked && (
                            <div className="blocked-number">
                              <span className="icon-ellipse-container">
                                <img className="ellipse" src={Ellipse} />
                                <img className="line" src={Line} />
                              </span>
                              Blocked
                            </div>
                          )}
                          {blockStatus.optout && (
                            <div className="blocked-number">
                              <span className="icon-ellipse-container">
                                <img className="optout1" src={optout_1} />
                                <img className="optout2" src={optout_2} />
                              </span>
                              Opted out
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="select-contact">
                          <div className="to">To:</div>
                          {!selectedContact ? (
                            <div className="contact-name">
                              <input
                                className="contact-name_input"
                                placeholder="Search by contact name, phone number or email"
                                value={searchText}
                                onChange={this.searchConversationFunc}
                                autoFocus={window.innerWidth > 767}
                              />
                            </div>
                          ) : (
                            <div className="contact-selection">
                              <span className="fullname">
                                {(selectedContact.firstName ||
                                  selectedContact.first_name) +
                                  ' ' +
                                  (selectedContact.lastName ||
                                    selectedContact.last_name)}
                              </span>
                              <span className="phonenumber">
                                {getPhoneNumber(selectedContact)}
                              </span>{' '}
                              <div
                                className="close-btn"
                                onClick={this.clearContactSelection}
                              >
                                <img src={closeIcon} />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {!createNewConversation && (
                      <div className="action-and-filter">
                        <a
                          className="action-and-filter_action"
                          onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();

                            this.setneedsattentionVisibility(
                              !needsattentionVisibility,
                            );
                          }}
                        >
                          <span className={conversationStatus.className}>
                            <i className="material-icons">
                              {conversationStatus.iconclassName}
                            </i>
                            <span className="label">
                              {conversationStatus.label}
                            </span>
                          </span>
                          <i className="material-icons">expand_more</i>
                        </a>
                        <MarkAsResolved
                          visibility={needsattentionVisibility}
                          position="bcz"
                          onVisibilityChange={(visibility) => {
                            this.setneedsattentionVisibility(visibility);
                          }}
                          selectedOption={conversationStatus.value}
                          className="conversation-action-list"
                          onChange={this.handleConvStatusChange}
                        />
                        <div className="action-and-filter_filter">
                          <a
                            href="#"
                            onClick={(event) => {
                              event.stopPropagation();
                              event.preventDefault();
                              this.setStatusDropdownVisibility(
                                !statusDropdownVisibility,
                              );
                            }}
                            className={cx({
                              'active-dropdowmn': statusDropdownVisibility,
                            })}
                          >
                            <i className="material-icons">more_vert</i>
                          </a>
                          <StatusSelectDropdown
                            visibility={statusDropdownVisibility}
                            position="br"
                            onVisibilityChange={(visibility) => {
                              this.setStatusDropdownVisibility(visibility);
                            }}
                            allowedOptions={['Report', 'Block']}
                            blockKnownNumber={true}
                            isBlocked={blockStatus?.blocked}
                            selectedOption={conversationStatus.value}
                            className="menu__dropdown report-block"
                            onChange={this.handleStatusChange}
                          />
                        </div>
                      </div>
                    )}
                    {createNewConversation &&
                      !selectedContact &&
                      searchText?.length > 0 &&
                      filteredContacts?.length > 0 ? (
                      <>
                        {this.state.searchLoading ? (
                          <div className="contact-search-result">
                            <div className="loading">
                              <Loading />
                            </div>
                          </div>
                        ) : (
                          <div className="contact-search-result">
                            <div className="contact-search-result_container">
                              {filteredContacts.map((contact) => {
                                return (
                                  <div
                                    className="contact-search-result_container_contact"
                                    onClick={() => this.selectContact(contact)}
                                  >
                                    {generateTemplate(
                                      contact.firstName +
                                      ' ' +
                                      contact.lastName,
                                      searchText,
                                    )}
                                    <span className="contact-search-result_container_contact_phone">
                                      {generateTemplate(
                                        getPhoneNumber(contact),
                                        searchText,
                                      )}
                                    </span>
                                    <span className="contact-search-result_container_contact_email">
                                      {generateTemplate(
                                        getEmail(contact),
                                        searchText,
                                      )}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="contact-search-result_nocontact">
                              Not the results you expected?{' '}
                              <span
                                className="contact-search-result_nocontact_heighlight"
                                onClick={() => this.createContact(true)}
                              >
                                Add new contact.
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ) : createNewConversation &&
                      searchText?.length > 0 &&
                      !selectedContact ? (
                      <>
                        {this.props.searchLoading ? (
                          <div className="contact-search-result">
                            <div className="loading">
                              <Loading />
                            </div>
                          </div>
                        ) : (
                          <div className="contact-search-result">
                            <div className="contact-search-result_nocontact">
                              No results.{' '}
                              <span
                                className="contact-search-result_nocontact_heighlight"
                                onClick={() => this.createContact(true)}
                              >
                                Add new contact?
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ) : null}
                    {createNewContact && !selectContactpage && (
                      <CreateContact
                        setblockOverlayVisibility={this.createContact}
                        modelopen={createNewContact}
                        phone={helpers.getClientPhone(conversation)}
                        selectedConversation={conversation}
                        auth={auth}
                        business={business}
                        blockUser={blockUser}
                        errorData={errorData}
                        getBlockUser={getBlockUser}
                        clearBlockData={clearBlockData}
                        clearReportFlags={clearReportFlags}
                        globalReport={false}
                        typeofUser={typeofUser}
                        saveContact={this.saveContact}
                        isAdvancedSearch={isAdvancedSearch}
                        createdContact={createdContact}
                        searchText={searchText}
                      />
                    )}
                    {selectContactpage && (
                      <SelectContact
                        setblockOverlayVisibility={this.selectedContactToggle}
                        modelopen={selectContactpage}
                        phone={helpers.getClientPhone(conversation)}
                        selectedConversation={conversation}
                        auth={auth}
                        business={business}
                        blockUser={blockUser}
                        unblockPhone={unblockPhone}
                        errorData={errorData}
                        getBlockUser={getBlockUser}
                        clearBlockData={clearBlockData}
                        clearReportFlags={clearReportFlags}
                        globalReport={false}
                        typeofUser={typeofUser}
                        createdContact={createdContact}
                        advancedSearch={advancedSearch}
                        selectContact={this.selectContact}
                        editContact={this.editContact}
                      />
                    )}
                  </div>
                  <div className="conversation-details_header_tags">
                    {!addOnNotEnabled && (
                      <div className="transcript-filter">
                        <div className="autoresponse">
                          <div className={classNames("assignment", { "assignment-disabled": assignment_disabled })}>
                            <a
                              href="#"
                              onClick={(event) => {
                                event.stopPropagation();
                                event.preventDefault();
                                this.setuserdropdownVisibility(
                                  !userdropdownVisibility,
                                );
                              }}
                            >
                              {assignedTo ? (
                                logoName ? (
                                  <div className="logo">{logoName}</div>
                                ) : (
                                  <div className="logo">
                                    <img src={Profile} />
                                  </div>
                                )
                              ) : (
                                <div className="none">
                                  <img src={Logo} />
                                </div>
                              )}
                              {!createNewConversation && (
                                <i className="material-icons">
                                  arrow_drop_down
                                </i>
                              )}
                            </a>
                            {!createNewConversation && (
                              <StaffAssignList
                                visibility={userdropdownVisibility}
                                position="bl"
                                onVisibilityChange={(visibility) => {
                                  this.setuserdropdownVisibility(visibility);
                                }}
                                className="menu__dropdown location-selection"
                                onChange={(event) => {
                                  this.assignUser(event);
                                }}
                                selectedOption={assignedUser}
                                assignedTo={assignedTo}
                                dropdownMenu={list}
                                dropdownType={dropdownType}
                                auth={auth}
                                allAssignmentMap={allAssignmentMap}
                              />
                            )}
                          </div>
                          <ReactTooltip />

                          <div className="auto-response-status">
                            <div className="auto-response-status_name">
                              {getFullName(
                                assignedTo,
                                list,
                                allAssignmentMap,
                                auth.userid,
                              )}
                            </div>
                            <div
                              className={cx('auto-response-status_info', {
                                active: dropdownType === 0,
                              })}
                            >
                              (
                              {dropdownType === 1 || dropdownType === 2
                                ? 'Auto-response paused'
                                : 'Auto-response active'}
                              )
                            </div>
                          </div>
                        </div>
                        {!createNewConversation && (
                          <div className="assignment_filter">
                            <div className="filter">
                              <a
                                href="#"
                                className={cx({
                                  'active-dropdowmn': filterdropdownVisibility,
                                })}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  event.preventDefault();
                                  this.setfilterdropdownVisibility(
                                    !filterdropdownVisibility,
                                  );
                                }}
                              >
                                {conversationFilterSelect !== 'FULL' ? (
                                  <div className="filter-logo">
                                    <img src={only_notes} />
                                  </div>
                                ) : (
                                  <div className="filter-logo">
                                    <img src={full_conversation} />
                                    <img
                                      className="second-img"
                                      src={full_conversation_bottom}
                                    />
                                  </div>
                                )}
                                <i className="material-icons">
                                  arrow_drop_down
                                </i>
                              </a>
                              <ConversationFilter
                                visibility={filterdropdownVisibility}
                                position="br"
                                onVisibilityChange={(visibility) => {
                                  this.setfilterdropdownVisibility(visibility);
                                }}
                                className="menu__dropdown conversation-filter-list"
                                onChange={(event) => {
                                  this.filterMessageType(event);
                                }}
                                selectedOption={conversationFilterSelect}
                                dropdownMenu={conversationfilter}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    <div className="conversation-tags">
                      <div className="tags-container">
                        <div className="tag-list">
                          <span className="tag">
                            {' '}
                            <span className="tag__name">
                              {helpers.getTypeofConversation(conversation)}
                            </span>
                          </span>
                        </div>
                        {tags && tags.includes('HAS_VOICE_MAIL') && (
                          <div
                            className="type-vm"
                            onClick={() => this.playVoiceMail(conversation)}
                          >
                            <i className="material-icons">voicemail</i>Voicemail
                          </div>
                        )}
                        {tags && tags.includes('HAS_VOICE_CALL') && (
                          <div
                            className="type-vm"
                            onClick={() => this.playVoiceMail(conversation)}
                          >
                            <img src={Voicecall} className="audio-icon" />Audio Recording
                          </div>
                        )}
                        {containing_locations &&
                          containing_locations.length > 0 && (
                            <>
                              <div className="divider"></div>
                              <div className="tag-list">
                                {containing_locations.map((location) => {
                                  return (
                                    <span className="tag">
                                      {' '}
                                      <span className="tag__name">
                                        {location.businessName}
                                      </span>
                                    </span>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        {annotations.length > 0 && (
                          <>
                            <div className="divider"></div>
                            <Tags
                              tags={annotations}
                              auth={auth}
                              typeofUser={typeofUser}
                              addTags={this.setCustomTagOverlayVisibility}
                              removeTag={this.removeCustomTags}
                              removingTag={removingTag}
                              removingTagToUser={removingTagToUser}
                              custom_tags={custom_tags}
                              conversation={conversation}
                              business={business}
                              softwares={softwares}
                              customTagDropdownVisibility={customTagDropdownVisibility}
                            />
                          </>
                        )}
                      </div>
                          {customTagDropdownVisibility && custom_tags.length > 0 &&
                            <CustomTags
                              setblockOverlayVisibility={this.setCustomTagOverlayVisibility}
                              modelopen={customTagDropdownVisibility}
                              custom_tags={custom_tags}
                              conversation_tags={conversation.conversation_tags}
                              conversation={conversation}
                              addCustomTags={this.addCustomTags}
                              addingTagToUser={addingTagToUser}
                            />
                          }

                      {addOnNotEnabled && (
                        <div className="filter">
                          <a
                            href="#"
                            onClick={(event) => {
                              event.stopPropagation();
                              event.preventDefault();
                              this.setfilterdropdownVisibility(
                                !filterdropdownVisibility,
                              );
                            }}
                          >
                            {conversationfilter === 0 ? (
                              <div className="filter-logo">
                                <img src={only_notes} />
                              </div>
                            ) : (
                              <div className="filter-logo">
                                <img src={full_conversation} />
                                <img
                                  className="second-img"
                                  src={full_conversation_bottom}
                                />
                              </div>
                            )}
                            <i className="material-icons">arrow_drop_down</i>
                          </a>
                          <ConversationFilter
                            visibility={filterdropdownVisibility}
                            position="bc"
                            onVisibilityChange={(visibility) => {
                              this.setfilterdropdownVisibility(visibility);
                            }}
                            className="menu__dropdown conversation-filter-list"
                            onChange={(event) => {
                              this.filterMessageType(event);
                            }}
                            selectedOption={conversationFilterSelect}
                            dropdownMenu={conversationfilter}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {showErrorMessage && errorMessage && (
                  <Overlay>
                    <div className="note-error-message">
                      {JSON.parse(errorMessage)}
                    </div>
                  </Overlay>
                )}
                <Transcript
                  getConversationTranscripts={getConversationTranscripts}
                  conversations={conversations}
                  business={this.props.business}
                  businessId={conversation.bzId}
                  selectedConversation={conversation}
                  showError={getconversationDetailsFail === conversation.userId}
                  isLoading={isLoadingTypescript}
                  createNewConversation={createNewConversation}
                  filter={conversationFilterSelect}
                  addOnNotEnabled={this.props.addOnNotEnabled}
                  addNotes={this.addNotes}
                  StaffManagement={this.props.StaffManagement}
                  auto_chat_status={auto_chat_status}
                  dropdownType={dropdownType}
                  selectedContact={selectedContact}
                />
                {reportOverlay && (
                  <Layover
                    setreportOverlayVisibility={this.setreportOverlayVisibility}
                    modelopen={true}
                    name={helpers.getNameform(conversation)}
                    phone={helpers.getClientPhone(conversation)}
                    selectedConversation={conversation}
                    auth={auth}
                    business={business}
                    erorReport={erorReport}
                    errorData={errorData}
                    clearReportFlags={clearReportFlags}
                    globalReport={false}
                    typeofUser={typeofUser}
                  />
                )}
                {blockOverlay && (
                  <BlockOverlay
                    setblockOverlayVisibility={this.setblockOverlayVisibility}
                    modelopen={true}
                    phone={helpers.getClientPhone(conversation)}
                    selectedConversation={conversation}
                    auth={auth}
                    isBlocked={blockStatus?.blocked}
                    business={business}
                    blockUser={blockUser}
                    unblockPhone={unblockPhone}
                    errorData={errorData}
                    getBlockUser={getBlockUser}
                    clearBlockData={clearBlockData}
                    clearReportFlags={clearReportFlags}
                    globalReport={false}
                    typeofUser={typeofUser}
                  />
                )}
                {optoutOverlay && (
                  <OptoutOverlay
                    selectedConversation={conversation}
                    setoptoutOverlayVisibility={this.setoptoutOverlayVisibility}
                    modelopen={true}
                    phone={helpers.getClientPhone(conversation)}
                    auth={auth}
                    business={business}
                    blockUser={blockUser}
                    errorData={errorData}
                    getOptOutnumbers={this.props.getOptOutnumbers}
                    getOptOutReport={this.props.getOptOutReport}
                    clearBlockData={clearBlockData}
                    clearReportFlags={clearReportFlags}
                    selectedLocation={selectedLocation}
                    typeofUser={typeofUser}
                  />
                )}
              </>
            )}
          </>
        )}
        {showCreateContactPopup && (
          <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Starting a new conversation with{' '}
            <span>{conversation.userName || conversation.userPhone}</span>
          </div>
        )}
        {showCallerNameSucess && (
          <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Caller name updated successfully
          </div>
        )}
        {showCallerNameFailure && (
          <div className="copy-webhook-failure">
            <span className="tick-mark">
              <i className="material-icons">close</i>
            </span>
            Caller name updated failed
          </div>
        )}
        {showRedirectContactPopup && (
          <div className="copy-webhook">
            <span className="tick-mark">
              <i className="material-icons">check</i>
            </span>
            Redirecting to existing conversation for{' '}
            <span>{conversation.userName || conversation.userPhone}</span>
          </div>
        )}
      </div>
    );
  }
}

export default ConversationDetails;
